module.exports = "/_next/static/images/9999ce10d76f43af63b8dcfaa3a35d1f-document-avatar-4x.png";